module.exports = __webpack_public_path__ + "LatoLatin-Italic.6b654922e092ce676796.woff";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/LatoLatin/fonts/LatoLatin-Italic.woff
// module id = ../../../../../src/assets/fonts/LatoLatin/fonts/LatoLatin-Italic.woff
// module chunks = styles